import { Separator, type SeparatorRootProps } from "@heroui/react";
import {
  type AppSeparatorOrientation,
  type AppSeparatorVariant,
} from "./variants";

/**
 * Constrained separator props.
 * className escape hatch available for one-off overrides.
 */
export type AppSeparatorProps = Omit<
  SeparatorRootProps,
  "className" | "orientation" | "variant"
> & {
  /** Orientation. @default "horizontal" */
  orientation?: AppSeparatorOrientation;
  /** Visual variant. @default "default" */
  variant?: AppSeparatorVariant;
  /** Optional className escape hatch for one-off overrides. */
  className?: string;
};

/**
 * AppSeparator — Design system horizontal/vertical divider.
 *
 * Wraps HeroUI v3 Separator with constrained Rosé Pine variants.
 *
 * @example
 * ```tsx
 * <AppSeparator orientation="horizontal" />
 * <AppSeparator orientation="vertical" variant="secondary" />
 * ```
 */
export function AppSeparator({
  orientation = "horizontal",
  variant = "default",
  className,
  ...props
}: AppSeparatorProps) {
  return <Separator {...props} orientation={orientation} variant={variant} className={className} />;
}
